import { IRBDItem } from "../../../../models/rbd"
import { IDiagramValues } from "../Diagram"
import finder, { SELECTOR } from "../helper/finder"
import { isElement, isSerialTransmission, isParalelTransmission, isRedundantTransmission } from "../helper/validator"
import { handleElement, handleSerial, handleParalel } from '.'
import { diagram } from "../constants"

export function handleRedundant(current: IRBDItem, prev: IRBDItem): IDiagramValues[] {
    let result: IDiagramValues[] = []

    let transmissionElement = finder(current, SELECTOR.TRANSMISSION_ELEMENTS)

    if (Array.isArray(transmissionElement)) {
        transmissionElement.map((i, x) => {
            if (isElement(i)) {
                const element = handleElement(i, prev)
                return result.push(element)
            } else {
                if (isSerialTransmission(i)) {
                    const serial = handleSerial(i, prev)
                    result.push(...serial)
                } else if (isParalelTransmission(i)) {
                    const paralel = handleParalel(i, prev)
                    result.push(...paralel)
                } else if (isRedundantTransmission(i)) {
                    const redundant = handleRedundant(i, prev)
                    result.push(...redundant)
                }
            }
            return undefined
        })
    }

    result = handleRedundantVisibility(current, result)

    const connector = generateRedundantConnector(transmissionElement, current.sequence)
    result.push(connector)
    
    return result;
}

function generateRedundantConnector(elements: IRBDItem[], key: number): IDiagramValues {
    let parent: number[] = [];

    elements.map(i => {
        if (isElement(i)) {
            parent.push(i.sequence)
        } else {
            if (isSerialTransmission(i)) {
                const elements = finder(i, SELECTOR.TRANSMISSION_ELEMENTS)
                parent.push(elements[elements.length - 1].sequence)
            } else if (isParalelTransmission(i)) {
                alert('paralel belum bisa di redundant')
                // TODO: handle when child is paralel
            } else if (isRedundantTransmission(i)) {
                alert('redundant belum bisa di redundant')
                // TODO: handle when child is redundant
            }
        }
        return undefined;
    })
    
    return {
        color: diagram.node.color.connector,
        figure: diagram.node.figure.circle,
        key: key,
        strokeColor: diagram.node.color.border.connector,
        linkColor: diagram.link.color.show,
        text: `1/${elements.length}`,
        width: diagram.node.width.circle,
        containerWidth: diagram.node.width.circle + 2,
        parent: parent
    }
}

/**
 * set the invisible link for spesific relation in redundant transmission
 * 
 * @param current
 * @param result
 * @return
 */
export function handleRedundantVisibility(current: IRBDItem, result: IDiagramValues[]): IDiagramValues[] {
    const elements = finder(current, SELECTOR.TRANSMISSION_ELEMENTS)
    let keyOfInvisibleLink: number[] = []

    if (Array.isArray(elements)) {
        elements.forEach((i, x) => {
            if (x > 0) {
                if (isElement(i)) {
                    keyOfInvisibleLink.push(i.sequence)
                } else {
                    if (isSerialTransmission(i)) {
                        const el = finder(i, SELECTOR.TRANSMISSION_ELEMENTS)
                        keyOfInvisibleLink.push(el[0].sequence)
                    }
                    // TODO: handle transmission here
                }
            }
        })
    }

    keyOfInvisibleLink.forEach(k => {
        result.filter(e => e.key === k && 
            (e.linkColor = diagram.link.color.hide)
        )
    })

    return result;
}